"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const video = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-video` : '') + (description ? ` desc-video` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-video"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-video"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.194 11.0474L2.94331 2.06854C2.50992 1.85532 2 2.16541 2 2.64218L2 20.6C2 21.0768 2.50992 21.3868 2.94331 21.1736L21.194 12.1947C21.6744 11.9584 21.6744 11.2838 21.194 11.0474ZM19.4459 11.6211L3.30362 19.5618L3.30362 3.67945L19.4459 11.6211Z",
    fill: "inherit"
  }));
};
var _default = exports.default = video;